export default __webpack_public_path__ + "static/media/undo-outline.ced23c7a.svg";